import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

import { MessageService } from '@services/message.service';
import { DadosContaApiService } from '../services/dados-conta-api.service';

@Component({
  selector: 'app-dados-conta',
  templateUrl: './dados-conta.component.html',
  styleUrl: './dados-conta.component.scss',
  standalone: false,
})
export class DadosContaComponent implements OnInit {

  login = '';

  formDados: FormGroup;
  formSenha: FormGroup;

  salvandoDados = false;
  salvandoSenha = false;
  erroTrocarSenha: string | null = null;

  constructor(
    private fb: FormBuilder,
    private dadosContaApiService: DadosContaApiService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.formDados = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.formSenha = this.fb.group({
      senhaAtual: ['', Validators.required],
      novaSenha: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d).+$/)]],
      confirmacaoNovaSenha: ['', Validators.required],
    });

    this.dadosContaApiService.obterDadosConta().subscribe({
      next: (dadosConta) => {
        this.login = dadosConta.login;
        this.formDados.patchValue({ email: dadosConta.email });
      },
    });
  }

  get senhasNaoConferem(): boolean {
    const { novaSenha, confirmacaoNovaSenha } = this.formSenha.value;
    return !!confirmacaoNovaSenha && novaSenha !== confirmacaoNovaSenha;
  }

  salvarDadosClick(): void {
    if (this.formDados.invalid) {
      this.formDados.markAllAsTouched();
      return;
    }

    this.salvandoDados = true;
    const { email } = this.formDados.value;

    this.dadosContaApiService.editarDados(email!).subscribe({
      next: () => {
        this.messageService.showToastSuccess('Dados da conta atualizados com sucesso.');
        this.salvandoDados = false;
      },
      error: () => {
        this.salvandoDados = false;
      },
    });
  }

  trocarSenhaClick(): void {
    if (this.formSenha.invalid) {
      this.formSenha.markAllAsTouched();
      return;
    }

    if (this.senhasNaoConferem) {
      return;
    }

    this.salvandoSenha = true;
    this.erroTrocarSenha = null;
    const { senhaAtual, novaSenha } = this.formSenha.value;

    this.dadosContaApiService.trocarSenha(senhaAtual!, novaSenha!).subscribe({
      next: () => {
        this.messageService.showToastSuccess('Senha alterada com sucesso.');
        this.formSenha.reset();
        this.salvandoSenha = false;
      },
      error: (err: HttpErrorResponse) => {
        // Reforça o toast com uma mensagem fixa no formulário, caso o usuário não repare o toast.
        this.erroTrocarSenha = err.error?.errors?.[0]?.errorMessage ?? 'Não foi possível trocar a senha.';
        this.salvandoSenha = false;
      },
    });
  }

  isInvalidDados(campo: string): boolean {
    const control = this.formDados.get(campo);
    return !!control && control.invalid && control.touched;
  }

  isInvalidSenha(campo: string): boolean {
    const control = this.formSenha.get(campo);
    return !!control && control.invalid && control.touched;
  }
}
